import { render, staticRenderFns } from "./ProductFrame.vue?vue&type=template&id=fc0a4568&scoped=true"
import script from "./ProductFrame.vue?vue&type=script&lang=js"
export * from "./ProductFrame.vue?vue&type=script&lang=js"
import style0 from "./ProductFrame.vue?vue&type=style&index=0&id=fc0a4568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0a4568",
  null
  
)

export default component.exports